import { constNull } from '@effect/data/Function';
import * as S from '@effect/schema/Schema';
import { Challenge, Channel } from '@infl-ts/util-fetch-challenge-list';
import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var SortByMap = {
  RECOMMENDED: 'RECOMMENDED',
  NEWEST: 'NEWEST',
  OLDEST: 'OLDEST'
};
export var ChallengeCarouselSortBy = keysWithMap(SortByMap);
export var CarouselChallengesQuery = t.type({
  challenges: nullable(t.type({
    edges: nullable(t.array(t.type({
      node: nullable(Challenge)
    })))
  })),
  channels: nullable(t.type({
    edges: nullable(t.array(t.type({
      node: nullable(Channel)
    })))
  }))
});
export var ChallengeIdsQuery = t.type({
  challenges: nullable(t.array(nullable(Challenge))),
  channels: nullable(t.type({
    edges: nullable(t.array(t.type({
      node: nullable(Channel)
    })))
  }))
});
export var ChallengeIdsQueryInput = t.partial({
  challengeIds: t.readonly(t.array(t.string)),
  challengeSort: ChallengeCarouselSortBy,
  numChannels: t.number,
  categoryIds: t.readonly(t.array(t.string))
});
export var CarouselChallengesQueryInput = t.partial({
  channelId: t.string,
  categoryIds: t.readonly(t.array(t.string)),
  numChallenges: t.number,
  numChannels: t.number,
  challengeSort: ChallengeCarouselSortBy,
  includeChannelContent: t["boolean"]
});
var ChallengeSortSchema = S.enums(SortByMap);
export var ChallengeCarouselBlockConfig = S.struct({
  typename: S.literal('ChallengeCarouselBlock'),
  id: S.string,
  hash: S.string,
  categories: S.nullable(S.array(S.string)),
  title: S.optional(S.nullable(S.string)).withDefault(constNull),
  numberOfChannels: S.number,
  challengeSort: ChallengeSortSchema,
  includeChannelContent: S["boolean"],
  numberOfChallenges: S.nullable(S.number),
  filterByChannelId: S.nullable(S.string),
  filterByChallengeIds: S.nullable(S.array(S.string))
});